import { useLocation } from "react-router-dom"

import { useUI } from "providers/UIProvider"
import { useTransactionsContext } from "providers/TransactionsProvider/TransactionsProvider"

import BdsLogo from "assets/img/bds-logo.png"
import { Text, Image, Flex } from "@chakra-ui/react"

import { getColumns } from "./columns"
import { getNestedColumns } from "./nestedColumns"

import Table from "components/UI/organisms/Table"
import RefundModal from "components/shared/modals/RefundModal"
import { ITransaction } from "types/transaction"
import { useAppContext } from "providers/AppProvider/AppProvider"
import { IRoles } from "types/shared"

const TransactionsTable: React.FC = () => {
  const { pathname } = useLocation()

  const { toggleModal, modals, T, lang } = useUI()
  const { transactions, query, handlePaginationClick } = useTransactionsContext()
  const { user } = useAppContext()


  const handleRefundClick = (data: ITransaction) => {
    toggleModal("refundModal", true,
      { transactionId: data.id, bankTransactionId: data.bankTransactionId, price: data.amount }
    )
  }

  // @ts-ignore
  const isRefundDisabled = user?.roles[0] === IRoles.QAPP_MANAGER;

  const columns = getColumns(T)
  const nestedColumns = getNestedColumns(T, lang, handleRefundClick, isRefundDisabled)

  const displayHeader = pathname === "/transactions"

  return (
    <>
      <Table
        data={transactions.data}
        columns={columns}
        nestedColumns={nestedColumns}
        displayHeader={displayHeader}
        collapseButton={true}
        extraHeaderCols={1}
        pagination={{
          total: transactions.itemCount,
          perPage: query.pageSize,
          currentPage: query.pageIndex,
          onClick: handlePaginationClick
        }}
      />
      <Flex style={{ flexDirection: "row", justifyContent: "center", alignItems: "center", gap: "5px", height: "2rem" }}>
        <Text style={{
          opacity: "50%",
          fontSize: "11px",
          whiteSpace: "nowrap",
        }}>
          {"Powered by"}
        </Text>
        <a target='_blank'
          rel='noopener noreferrer' href="https://bds.ge">
          <Image alt="BDS Logo" src={BdsLogo} height="14px" />
        </a>
      </Flex>
      {modals.refundModal.isOpened && <RefundModal />}
    </>
  )
}

export default TransactionsTable

